<template>
  <v-container :fluid="fluid" data-testid="so-container">
    <slot></slot>
  </v-container>
</template>

<script lang="ts">
  import { defineComponent } from "vue"

  export default defineComponent({
    props: {
      fluid: {
        type: Boolean,
        default: false,
      },
    },
  })
</script>
